import * as PIXI from "pixi.js";
import { BasePopupScene } from "./BasePopupScene.js";

export class SessionExpiredPopupScene extends BasePopupScene {
    create() {
        super.create();
        const message = this.options?.message ?? "Session expired";

        this._panel.position.set(960, 540);

        const bgTex = this.services.get("resources").get("session_expired/bg");
        if (bgTex) {
            const bg = new PIXI.Sprite(bgTex);
            bg.anchor.set(0.5);
            this._panel.addChild(bg);
        }

        const text = new PIXI.Text({
            text: message,
            style: { fontFamily: "halant_bold", fontSize: 28, fill: 0xffffff, wordWrap: true, wordWrapWidth: 400 },
        });
        text.anchor.set(0.5);
        this._panel.addChild(text);

        const reloadTex = this.services.get("resources").get("session_expired/reload_btn/default");
        if (reloadTex) {
            const btn = new PIXI.Sprite(reloadTex);
            btn.anchor.set(0.5);
            btn.position.set(0, 100);
            btn.eventMode = "static";
            btn.cursor = "pointer";
            btn.on("pointertap", () => window.location.reload());
            this._panel.addChild(btn);
        }
    }
}
